/**
 * Configuración centralizada de URLs de API
 * Usa variables de entorno para diferentes ambientes
 */

// URL base del backend
// NOTA: Hardcodeado temporalmente porque Netlify no está leyendo las variables de entorno correctamente
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://superautoresponder-production.up.railway.app';

// URL de la API (con /api)
export const API_URL = `${API_BASE_URL || ''}/api`;

if (!API_BASE_URL) {
  // En desarrollo, lanza un error para que sea obvio que falta la variable.
  if (process.env.NODE_ENV === 'development') {
    throw new Error('La variable de entorno REACT_APP_API_URL no está definida. Por favor, crea un archivo .env y añádela.');
  }
  // En producción, es mejor registrar un error y dejar que la app falle más adelante
  // si intenta hacer una llamada a una URL indefinida.
  console.error('Error crítico: La variable de entorno REACT_APP_API_URL no está configurada para el build de producción.');
}

// URL del Socket.io
export const SOCKET_URL = API_BASE_URL;

// Configuración de Socket.io
export const SOCKET_CONFIG = {
    reconnection: true,
    reconnectionDelay: 2000,        // Aumentado de 1s a 2s
    reconnectionDelayMax: 10000,    // Aumentado de 5s a 10s
    reconnectionAttempts: 10,       // Aumentado de 5 a 10 intentos
    timeout: 60000,                 // Aumentado de 20s a 60s (1 minuto)
    pingTimeout: 60000,             // Nuevo: timeout para ping/pong
    pingInterval: 25000,            // Nuevo: intervalo de ping cada 25s
    autoConnect: false,
    transports: ['websocket', 'polling'],
    upgrade: false,                 // Nuevo: evitar upgrade de polling a websocket
    rememberUpgrade: true           // Nuevo: recordar upgrade exitoso
};

// Endpoints comunes
export const ENDPOINTS = {
    // Admin
    ADMIN_USERS: `${API_URL}/admin/all-users`,
    ADMIN_STATS: `${API_URL}/admin/user-stats`,
    ADMIN_CHANGE_PLAN: (userId) => `${API_URL}/admin/users/${userId}/change-plan`,
    
    // Payments
    PAYMENTS_PRICING: `${API_URL}/payments/pricing`,
    
    // Subscription
    SUBSCRIPTION_STATUS: `${API_URL}/subscription/status`,
    
    // PayPal
    PAYPAL_CREATE: `${API_URL}/paypal/create-subscription`,
    PAYPAL_VERIFY: `${API_URL}/paypal/verify-subscription`,
    
    // Usage
    USAGE_SUMMARY: `${API_URL}/usage/summary`,
    
    // Meta
    META_LINK: `${API_URL}/meta/link`,
    
    // Settings
    SETTINGS: `${API_URL}/settings`,
    
    // QR Link
    QR_LINK_VALIDATE: (token) => `${API_URL}/qr-link/validate/${token}`,
    QR_LINK_QR: (token) => `${API_URL}/qr-link/qr/${token}`,
    QR_LINK_GENERATE: `${API_URL}/qr-link/generate`,

    // WhatsApp Cloud Access (admin)
    WHATSAPP_CLOUD_ACCESS_ME: `${API_URL}/admin/whatsapp-cloud-access/me`,
    WHATSAPP_CLOUD_ACCESS_LIST: `${API_URL}/admin/whatsapp-cloud-access`,
    WHATSAPP_CLOUD_ACCESS_GRANT: `${API_URL}/admin/whatsapp-cloud-access/grant`,
    WHATSAPP_CLOUD_ACCESS_REVOKE: `${API_URL}/admin/whatsapp-cloud-access/revoke`,
};

export const TEST_MESSAGE = 'Mensaje de prueba ✅';
export const EXAMPLE_URL = 'https://miempresa.com';

// Feature Flags (se leen durante el build)
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

export const FEATURE_FLAGS = {
    WHATSAPP_WEB_ENABLED: process.env.REACT_APP_ENABLE_WHATSAPP_WEB === 'true',
    PAYPAL_CONFIGURED: !!(PAYPAL_CLIENT_ID && PAYPAL_CLIENT_ID !== 'undefined')
};

export default {
    API_BASE_URL,
    API_URL,
    SOCKET_URL,
    SOCKET_CONFIG,
    ENDPOINTS,
    TEST_MESSAGE,
    FEATURE_FLAGS
};
